import { MocksNotificationServiceNow } from '__mocks__/servicenow/notification'
import { MocksVariablesServiceNow } from '__mocks__/servicenow/variables'
import { MocksLocationServiceNow } from '__mocks__/servicenow/location'
import { MocksSectorServiceNow } from '__mocks__/servicenow/sector'
import { MocksUserServiceNow } from '__mocks__/servicenow/user'
import { Mock } from 'types/global'

export const MocksServiceNow:Mock[] = [...MocksNotificationServiceNow, ...MocksVariablesServiceNow, ...MocksLocationServiceNow, ...MocksSectorServiceNow, ...MocksUserServiceNow]